var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAddToCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 8.25H9.5V6H8.75V8.25H6.5V9H8.75V11.25H9.5V9H11.75V8.25Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.25C11 1.8375 10.6625 1.5 10.25 1.5H8.75V0.75H8V1.5H5V0.75H4.25V1.5H2.75C2.3375 1.5 2 1.8375 2 2.25V9.75C2 10.1625 2.3375 10.5 2.75 10.5H5.75V9.75H2.75V2.25H4.25V3H5V2.25H8V3H8.75V2.25H10.25V5.25H11V2.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddToCalendar);
export default __webpack_public_path__ + "static/media/ic-add-to-calendar.a06693b68e1056b457f5eba6b9cfeff9.svg";
export { ForwardRef as ReactComponent };